import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Modal } from 'antd';
import MyText from '../myText/MyText';
import MyFlex from '../myFlex/MyFlex';
import { useTranslation } from 'react-i18next';
import UtilString from '../../utils/UtilString';
import MyButtonMain from '../myButton/MyButtonMain';
import MyButtonSecondary from '../myButton/MyButtonSecondary';
import './MyModal.scss';

const MyModal = forwardRef(
  (
    {
      onOk,
      title,
      saving,
      onClose,
      labelOk,
      footer,
      height,
      loading,
      children,
      disableOk,
      trigerText,
      hideFooter,
      width = 450,
      btnLoading,
      danger = false,
      onVisibleChange,
      forceRender = false,
      getContainer = false,
      destroyOnHidden = true,
      className = UtilString.EMPTY_STRING,
    },
    ref
  ) => {
    const { t } = useTranslation();

    const [open, setOpen] = useState(false);

    const showModal = () => {
      setOpen(true);
      onVisibleChange && onVisibleChange(true);
    };

    const handleCancel = () => {
      setOpen(false);
      onVisibleChange && onVisibleChange(false);
    };

    useImperativeHandle(ref, () => ({
      open: () => {
        showModal();
      },
      close: () => {
        handleCancel();
      },
    }));

    useEffect(() => {
      if (!open) {
        onClose && onClose();
      }
    }, [open, onClose]);

    return (
      <>
        <div onClick={showModal}>{trigerText}</div>
        <Modal
          className={className}
          title={<MyText bold>{title}</MyText>}
          open={open}
          loading={loading}
          confirmLoading={saving}
          onCancel={handleCancel}
          width={width}
          height={height}
          destroyOnHidden={destroyOnHidden}
          getContainer={getContainer}
          forceRender={forceRender}
          centered
          classNames={{
            container: 'my_modal_container',
            body: 'my_modal_body',
          }}
          footer={
            footer || (
              <MyFlex block justify="space-between">
                {hideFooter ? null : (
                  <MyFlex align="start" className="margin_top_4">
                    <MyButtonSecondary
                      key="cancel"
                      onClick={handleCancel}
                      label={t('WORD_CANCEL')}
                    />
                    <MyButtonMain
                      key="ok"
                      onClick={onOk}
                      label={labelOk || t('WORD_OK')}
                      disabled={disableOk}
                      danger={danger}
                      loading={btnLoading}
                      className="min_width_86px"
                    />
                  </MyFlex>
                )}
              </MyFlex>
            )
          }
        >
          {children}
        </Modal>
      </>
    );
  }
);

export default MyModal;
